import React from "react";

function ContactUs() {
  return (
    <div
      className="flex h-auto p-10 w-full flex-col gap-10 justify-center"
      id="contact_us"
    >
      <div className="flex justify-center items-center flex-col">
        <div className="text-3xl font-bold">Contact Us</div>
        <div className="w-[80px] h-0.5 bg-green-900 my-5"></div>
        <span className="text-gray-400">
          Any question or concerns? Contact and visit us.
        </span>
      </div>
      <div className="grid lg:grid-cols-3 mx-auto gap-10 mt-6">
        <div className="lg:col-span-1 col-span-3 text-center">
          <h6 className="font-medium">ADDRESS</h6>
          <ul>
            <li className="py-2 text-sm">Protected Area Management Office (PAMO)</li>
            <li className="py-2 text-sm">DENR Park Station, Sitio Malauyas</li>
            <li className="py-2 text-sm">Brgy. Sapang I, Ternate, Cavite</li>
          </ul>
        </div>
        <div className="lg:col-span-1 col-span-3 text-center">
          <h6 className="font-medium">CONTACT INFO</h6>
          <ul>
            <li className="py-2 text-sm">Email Address:</li>
            <li className="py-2 text-sm">admin@mppmngnp.com</li>
          </ul>
        </div>
        <div className="lg:col-span-1 col-span-3 text-center">
          <h6 className="font-medium">OFFICE HOURS</h6>
          <ul>
            <li className="py-2 text-sm">Monday – Friday</li>
            <li className="py-2 text-sm">8:00am-5:00pm</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
